type MarketingLocale = typeof import('../en/marketing').default

const marketing = {
	title: '{{brandName}}',
	description:
		'Consulta la <link>guía de inicio</link> para saber cómo poner en marcha tu proyecto {{brandName}}.',
	gettingStartedLink: 'Guía de inicio',
	courses: 'Aprender',
	nav: {
		signIn: 'Iniciar sesión',
		getStarted: 'Empieza gratis',
		home: 'Inicio',
		learn: 'Aprender',
		catalog: 'Catálogo',
		pricing: 'Precios',
		viewFullCatalog: 'Ver catálogo completo',
		searchPlaceholder: '¿Qué quieres aprender?',
		blog: 'Blog',
		about: 'Acerca de',
		contact: 'Contacto',
		legal: 'Legal',
		help: 'Ayuda',
	},
	pricing: {
		checkoutError: {
			title: 'No hemos podido iniciar el pago',
			body: 'Ha fallado la conexión con la pasarela de pago. Inténtalo de nuevo en unos segundos; no se te ha cobrado nada.',
			dismiss: 'Cerrar',
		},
	},
	legal: {
		index: {
			title: 'Información legal',
			description:
				'Consulta las condiciones de uso y privacidad aplicables a {{brandName}}.',
			trustCenter: 'Centro de confianza',
			lastUpdatedLabel: 'Última actualización',
			launchReadiness: 'Versión preparada para lanzamiento',
			openDocument: 'Abrir documento',
			availableDocuments: 'Documentos disponibles',
		},
		links: {
			terms: { title: 'Términos' },
			privacy: { title: 'Privacidad' },
			cookies: { title: 'Cookies' },
		},
		sectionLinkLabel: 'Enlace a esta sección',
		documentScope: {
			brand: 'Documento específico de marca',
		},
	},
	footer: {
		title: 'Pie de página',
		tagline: 'Construye tu conocimiento con {{brandName}}',
		exploreCategories: 'Explora las categorías más populares',
		noCategories: 'Las categorías estarán disponibles pronto.',
		freeBadge: 'Gratis',
		viewAllCollections:
			'Ver tod{{collectionEntityGenderSuffixPlural}} {{collectionEntityArticlePluralLower}} {{collectionEntityLabelPluralLower}}',
		sections: {
			categories: 'Categorías',
			categoryRoutes: 'Rutas por categoría',
			legal: 'Legal',
			more: 'Más',
		},
		copyright: '© {{year}} {{brandName}}. Todos los derechos reservados.',
	},
	social: {
		twitter: 'Twitter',
		email: 'Correo',
	},
	home: {
		title: 'Bienvenido',
		description:
			'Esta es una aplicación de demostración que muestra cómo usar i18n con react router 7.',
		getStarted: 'Empieza gratis',
	},
	about: {
		title: 'Acerca de',
		description:
			'Esta aplicación demuestra la integración de internacionalización con react router 7.',
	},
} satisfies MarketingLocale

export default marketing
